import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const BookOpen16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M12.6821 9.7276C13.0839 9.62714 13.3282 9.21994 13.2278 8.81809C13.1273 8.41624 12.7201 8.17192 12.3183 8.27238L10.3183 8.77238C9.91643 8.87285 9.67211 9.28005 9.77257 9.68189C9.87303 10.0837 10.2802 10.3281 10.6821 10.2276L12.6821 9.7276Z'
      fill='currentColor'
    />
    <path
      d='M13.2278 5.81815C13.3282 6.22 13.0839 6.6272 12.6821 6.72766L10.6821 7.22766C10.2802 7.32812 9.87303 7.0838 9.77257 6.68195C9.67211 6.28011 9.91643 5.87291 10.3183 5.77245L12.3183 5.27245C12.7201 5.17198 13.1273 5.4163 13.2278 5.81815Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.20604 1.27886C0.734651 1.14418 0.25 1.50975 0.25 2V12C0.25 12.3349 0.471983 12.6292 0.793959 12.7211L7.79396 14.7211C7.92863 14.7596 8.07137 14.7596 8.20604 14.7211L15.206 12.7211C15.528 12.6292 15.75 12.3349 15.75 12V2C15.75 1.50975 15.2653 1.14418 14.794 1.27886L8 3.21999L1.20604 1.27886ZM1.75 11.4343V2.9943L7.25 4.56573V13.0057L1.75 11.4343ZM8.75 13.0057L14.25 11.4343V2.9943L8.75 4.56573V13.0057Z'
      fill='currentColor'
    />
  </Svg>
);

BookOpen16.displayName = 'BookOpen16';
export default BookOpen16;
